import React from 'react'
import { NavLink } from 'react-router-dom';

const Footer = () => {

    const footerLinkStyle = ({ isActive }) => ({
        color: isActive ? "#E8212A" : "#fff",
        textDecoration: "none",
        transition: "all 0.3s ease",
    });

    return (
        <>
            <footer
                style={{
                    background: "#0d0d0d",
                    color: "#fff",
                    position: "relative",
                    overflow: "hidden",
                    animation: "fadeSlideUp .7s 1.1s both",
                }}
            >
                <div
                    style={{
                        height: "2px",
                        background:
                            "linear-gradient(90deg,transparent 0%,#E8212A 30%,#E8212A 70%,transparent 100%)",
                    }}
                />

                {/* bg texture */}
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        pointerEvents: "none",
                    }}
                >
                    <svg width="100%" height="100%">
                        <defs>
                            <pattern
                                id="fp"
                                x="0"
                                y="0"
                                width="28"
                                height="28"
                                patternUnits="userSpaceOnUse"
                            >
                                <circle
                                    cx="1.5"
                                    cy="1.5"
                                    r="1"
                                    fill="#E8212A"
                                    opacity=".06"
                                />
                            </pattern>
                        </defs>

                        <rect width="100%" height="100%" fill="url(#fp)" />
                    </svg>
                </div>

                <div
                    style={{
                        position: "absolute",
                        top: "-120px",
                        right: "-100px",
                        width: "400px",
                        height: "400px",
                        background:
                            "radial-gradient(circle,rgba(232,33,42,.07) 0%,transparent 68%)",
                        pointerEvents: "none",
                    }}
                />

                <div
                    style={{
                        position: "relative",
                        zIndex: 1,
                    }}
                >
                    {/* CTA Banner */}
                    <div
                        style={{
                            padding: "52px 24px",
                            borderBottom: "1px solid #1c1c1c",
                        }}
                    >
                        <div
                            style={{
                                maxWidth: "1440px",
                                margin: "0 auto",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                flexWrap: "wrap",
                                gap: "28px",
                            }}
                        >
                            <div style={{ maxWidth: "480px" }}>
                                <div
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        background: "rgba(232,33,42,.12)",
                                        border: "1px solid rgba(232,33,42,.2)",
                                        borderRadius: "100px",
                                        padding: "4px 12px",
                                        marginBottom: "14px",
                                    }}
                                >
                                    <span
                                        style={{
                                            width: "5px",
                                            height: "5px",
                                            borderRadius: "50%",
                                            background: "#E8212A",
                                            display: "inline-block",
                                            animation: "pulse 2s infinite",
                                        }}
                                    />

                                    <span
                                        style={{
                                            fontFamily: "'Plus Jakarta Sans',sans-serif",
                                            fontSize: "11px",
                                            fontWeight: 600,
                                            color: "#E8212A",
                                            letterSpacing: ".5px",
                                            textTransform: "uppercase",
                                        }}
                                    >
                                        Currently Accepting Projects
                                    </span>
                                </div>

                                <h2
                                    style={{
                                        fontFamily: "'Syne',sans-serif",
                                        fontWeight: 800,
                                        fontSize: "30px",
                                        color: "#fff",
                                        margin: "0 0 10px",
                                        letterSpacing: "-.8px",
                                        lineHeight: 1.1,
                                    }}
                                >
                                    Got an app idea?
                                    <br />
                                    <span style={{ color: "#E8212A" }}>
                                        Let's build it.
                                    </span>
                                </h2>

                                <p
                                    style={{
                                        fontFamily: "'Plus Jakarta Sans',sans-serif",
                                        fontSize: "14px",
                                        color: "#fff",
                                        lineHeight: 1.7,
                                        margin: 0,
                                    }}
                                >
                                    From a napkin sketch to a 5-star app — we handle
                                    design, development & deployment.
                                </p>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                    alignItems: "flex-end",
                                }}
                            >
                                <a
                                    href="tel:+1234567890"
                                    style={{
                                        fontFamily: "'Plus Jakarta Sans',sans-serif",
                                        fontWeight: 700,
                                        fontSize: "14px",
                                        color: "#fff",
                                        background: "#E8212A",
                                        padding: "14px 28px",
                                        borderRadius: "11px",
                                        textDecoration: "none",
                                        boxShadow: "0 4px 20px rgba(232,33,42,.35)",
                                        transition: "all .2s",
                                        whiteSpace: "nowrap",
                                        display: "inline-block",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-2px)";
                                        e.currentTarget.style.boxShadow =
                                            "0 8px 28px rgba(232,33,42,.5)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "";
                                        e.currentTarget.style.boxShadow =
                                            "0 4px 20px rgba(232,33,42,.35)";
                                    }}
                                >
                                    Book a Free Discovery Call →
                                </a>
                                <NavLink to="/Portfolio">
                                    <a
                                        href="#"
                                        style={{
                                            fontFamily: "'Plus Jakarta Sans',sans-serif",
                                            fontWeight: 500,
                                            fontSize: "13px",
                                            color: "#fff",
                                            textDecoration: "none",
                                            transition: "color .2s",
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.color = "#E8212A";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.color = "#fff";
                                        }}
                                    >
                                        Or view our app portfolio ↗
                                    </a>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                    {/* Main footer links */}
                    <div
                        style={{
                            maxWidth: "1440px",
                            margin: "0 auto",
                            padding: "48px 24px 32px",
                            display: "grid",
                            gridTemplateColumns:
                                window.innerWidth > 992
                                    ? "1.7fr 1fr 1fr 1fr"
                                    : "repeat(auto-fit, minmax(250px, 1fr))",
                            gap: "36px",
                        }}
                    >
                        {/* Brand col */}
                        <div>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "9px",
                                    marginBottom: "14px",
                                }}
                            >
                                <NavLink to="/">
                                    <div
                                        style={{
                                            background: "#fff",
                                            borderRadius: "10px",
                                            padding: "3px",
                                            boxShadow: "0 0 0 1px rgba(232,33,42,.3)",
                                        }}
                                    >
                                        <svg width="30" height="30" viewBox="0 0 80 80" fill="none">
                                            <path
                                                d="M18 58L40 18L62 58L53 58L40 32L27 58Z"
                                                fill="#1a1a1a"
                                            />

                                            <path d="M27 45L53 45L50 52L30 52Z" fill="#1a1a1a" />

                                            <rect
                                                x="46"
                                                y="16"
                                                width="5"
                                                height="5"
                                                rx="1.2"
                                                fill="#E8212A"
                                            />

                                            <rect
                                                x="53"
                                                y="10"
                                                width="4"
                                                height="4"
                                                rx="1"
                                                fill="#E8212A"
                                            />

                                            <rect
                                                x="61"
                                                y="15"
                                                width="3"
                                                height="3"
                                                rx="1"
                                                fill="#E8212A"
                                            />

                                            <ellipse
                                                cx="58"
                                                cy="52"
                                                rx="16"
                                                ry="8"
                                                stroke="#E8212A"
                                                strokeWidth="2.5"
                                                fill="none"
                                            />

                                            <circle cx="66" cy="45" r="3.5" fill="#E8212A" />
                                        </svg>
                                    </div>
                                </NavLink>
                                <span
                                    style={{
                                        fontFamily: "'Syne',sans-serif",
                                        fontWeight: 800,
                                        fontSize: "16px",
                                        color: "#fff",
                                    }}
                                >
                                    appverse
                                    <span style={{ color: "#E8212A" }}>labs</span>
                                </span>
                            </div>

                            <p
                                style={{
                                    fontFamily: "'Plus Jakarta Sans',sans-serif",
                                    fontSize: "13px",
                                    color: "#fff",
                                    lineHeight: 1.8,
                                    margin: "0 0 20px",
                                    maxWidth: "230px",
                                }}
                            >
                                Your end-to-end app development partner — iOS, Android &
                                cross-platform.
                            </p>

                            {/* Tech badges */}
                            <div
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "6px",
                                    marginBottom: "20px",
                                }}
                            >
                                <NavLink to="/Technologie/ReactNative">
                                    <span
                                        style={{
                                            fontFamily: "'Plus Jakarta Sans',sans-serif",
                                            fontSize: "10px",
                                            fontWeight: 600,
                                            color: "#fff",
                                            background: "#1e1e1e",
                                            border: "1px solid #2a2a2a",
                                            padding: "3px 8px",
                                            borderRadius: "5px",
                                        }}
                                    >
                                        React Native
                                    </span>
                                </NavLink>
                                <NavLink to="/Technologie/Flutter">
                                    <span
                                        style={{
                                            fontFamily: "'Plus Jakarta Sans',sans-serif",
                                            fontSize: "10px",
                                            fontWeight: 600,
                                            color: "#fff",
                                            background: "#1e1e1e",
                                            border: "1px solid #2a2a2a",
                                            padding: "3px 8px",
                                            borderRadius: "5px",
                                        }}
                                    >
                                        Flutter
                                    </span>
                                </NavLink>
                                <NavLink to="/Technologie/Swift">
                                    <span
                                        style={{
                                            fontFamily: "'Plus Jakarta Sans',sans-serif",
                                            fontSize: "10px",
                                            fontWeight: 600,
                                            color: "#fff",
                                            background: "#1e1e1e",
                                            border: "1px solid #2a2a2a",
                                            padding: "3px 8px",
                                            borderRadius: "5px",
                                        }}
                                    >
                                        Swift
                                    </span>
                                </NavLink>
                                <NavLink to="/Technologie/Kotlin">
                                    <span
                                        style={{
                                            fontFamily: "'Plus Jakarta Sans',sans-serif",
                                            fontSize: "10px",
                                            fontWeight: 600,
                                            color: "#fff",
                                            background: "#1e1e1e",
                                            border: "1px solid #2a2a2a",
                                            padding: "3px 8px",
                                            borderRadius: "5px",
                                        }}
                                    >
                                        Kotlin
                                    </span>
                                </NavLink>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    gap: "7px",
                                }}
                            >
                                <a className="sb" href="#">
                                    𝕏
                                </a>

                                <a className="sb" href="#">
                                    in
                                </a>

                                <a className="sb" href="#">
                                    Be
                                </a>

                                <a className="sb" href="#">
                                    GH
                                </a>
                            </div>
                        </div>

                        {/* Services */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Syne',sans-serif",
                                    fontWeight: 700,
                                    fontSize: "11.5px",
                                    color: "#fff",
                                    margin: "0 0 16px",
                                    letterSpacing: "1.8px",
                                    textTransform: "uppercase",
                                }}
                            >
                                Services
                            </h4>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "9px",
                                }}
                            >
                                <NavLink to="/IOSApp" style={footerLinkStyle}>
                                    iOS App Development
                                </NavLink>

                                <NavLink to="/Androidapps" style={footerLinkStyle}>
                                    Android App Development
                                </NavLink>

                                <NavLink to="/CrossPlatform" style={footerLinkStyle}>
                                    Cross-Platform App Development
                                </NavLink>
                                {/* <a className="fl" href="#">
                                    App UI/UX Design
                                </a>

                                <a className="fl" href="#">
                                    App Maintenance
                                </a>

                                <a className="fl" href="#">
                                    App Store Launch
                                </a> */}
                            </div>
                        </div>

                        {/* Company */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Syne',sans-serif",
                                    fontWeight: 700,
                                    fontSize: "11.5px",
                                    color: "#fff",
                                    margin: "0 0 16px",
                                    letterSpacing: "1.8px",
                                    textTransform: "uppercase",
                                }}
                            >
                                Company
                            </h4>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "9px",
                                }}
                            >
                                <NavLink to="/AboutUs" style={footerLinkStyle}>
                               
                                        About Us
                                   
                                </NavLink>
                                <NavLink to="/Portfolio" style={footerLinkStyle}>
       

                                        App Portfolio
                                  
                                </NavLink>
                                <NavLink to="/CaseStudies" style={footerLinkStyle}>
                                  
                                        Case Studies
                                    
                                </NavLink>


                                <NavLink to="/Careers" style={footerLinkStyle}>
                                  
                                        Careers
                                
                                </NavLink>
                            </div>
                        </div>

                        {/* Contact */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Syne',sans-serif",
                                    fontWeight: 700,
                                    fontSize: "11.5px",
                                    color: "#fff",
                                    margin: "0 0 16px",
                                    letterSpacing: "1.8px",
                                    textTransform: "uppercase",
                                }}
                            >
                                Contact
                            </h4>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "12px",
                                }}
                            >
                                <div>
                                    <div
                                        style={{
                                            fontFamily: "'Plus Jakarta Sans',sans-serif",
                                            fontSize: "11px",
                                            color: "#fff",
                                            textTransform: "uppercase",
                                            letterSpacing: "1px",
                                            marginBottom: "3px",
                                        }}
                                    >
                                        Email
                                    </div>

                                    <a
                                        href="#"
                                        style={{
                                            fontFamily: "'Plus Jakarta Sans',sans-serif",
                                            fontSize: "13px",
                                            color: "#fff",
                                            textDecoration: "none",
                                            transition: "color .16s",
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.color = "#E8212A";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.color = "#666";
                                        }}
                                    >
                                        hello@appverselabs.com
                                    </a>
                                </div>

                                <div>
                                    <div
                                        style={{
                                            fontFamily: "'Plus Jakarta Sans',sans-serif",
                                            fontSize: "11px",
                                            color: "#fff",
                                            textTransform: "uppercase",
                                            letterSpacing: "1px",
                                            marginBottom: "3px",
                                        }}
                                    >
                                        Location
                                    </div>

                                    <span
                                        style={{
                                            fontFamily: "'Plus Jakarta Sans',sans-serif",
                                            fontSize: "13px",
                                            color: "#fff",
                                        }}
                                    >
                                        B-608, Rk Iconic, Near Shital Park, 150 Feet Ring Road, Rajkot-360006.
                                    </span>
                                </div>


                            </div>
                        </div>
                    </div>

                    {/* Bottom bar */}
                    <div
                        style={{
                            borderTop: "1px solid #191919",
                            padding: "16px 24px",
                        }}
                    >
                        <div
                            style={{
                                maxWidth: "1440px",
                                margin: "0 auto",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                flexWrap: "wrap",
                                gap: "12px",
                            }}
                        >
                            <span
                                style={{
                                    fontFamily: "'Plus Jakarta Sans',sans-serif",
                                    fontSize: "12px",
                                    color: "#fff",
                                }}
                            >
                                © 2026 AppVerseLabs Pvt. Ltd. — App Development Studio,
                                Rajkot
                            </span>

                            <div
                                style={{
                                    display: "flex",
                                    gap: "18px",
                                }}
                            >
                                <NavLink
                                    to="/PrivacyPolicy"
                                    style={{
                                        fontFamily: "'Plus Jakarta Sans',sans-serif",
                                        fontSize: "12px",
                                        color: "#fff",
                                        textDecoration: "none",
                                        transition: "color .15s",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.color = "#E8212A";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.color = "#fff";
                                    }}
                                >
                                    Privacy
                                </NavLink>

                                <NavLink
                                    to="/Terms"
                                    style={{
                                        fontFamily: "'Plus Jakarta Sans',sans-serif",
                                        fontSize: "12px",
                                        color: "#fff",
                                        textDecoration: "none",
                                        transition: "color .15s",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.color = "#E8212A";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.color = "#fff";
                                    }}
                                >
                                    Terms
                                </NavLink>


                            </div>

                            {/* <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                }}
                            >
                                <span
                                    style={{
                                        fontFamily: "'Plus Jakarta Sans',sans-serif",
                                        fontSize: "11px",
                                        color: "#fff",
                                    }}
                                >
                                    Made in
                                </span>

                                <span style={{ fontSize: "14px" }}>🇮🇳</span>

                                <span
                                    style={{
                                        fontFamily: "'Plus Jakarta Sans',sans-serif",
                                        fontSize: "11px",
                                        color: "#fff",
                                    }}
                                >
                                    with
                                </span>

                                <span
                                    style={{
                                        color: "#E8212A",
                                        fontSize: "13px",
                                    }}
                                >
                                    ♥
                                </span>
                            </div> */}
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer